const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 21.6 26.397"
  >
    <path
      fill={color}
      stroke="none"
      d="M10.799 0C4.849 0 0 4.848 0 10.799c0 3.44 1.827 6.675 3.848 9.33s4.29 4.741 5.445 5.738l.064.051c.85.64 2.035.64 2.885 0l.063-.05c1.155-.998 3.426-3.084 5.447-5.74 2.02-2.654 3.848-5.89 3.848-9.33C21.6 4.849 16.75 0 10.799 0m0 2.398c4.653 0 8.4 3.747 8.4 8.4 0 2.553-1.497 5.433-3.357 7.878-1.835 2.41-3.95 4.37-5.041 5.316-1.092-.946-3.21-2.905-5.045-5.316-1.86-2.445-3.358-5.325-3.358-7.877 0-4.654 3.747-8.4 8.4-8.4"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      d="M10.799 6C8.162 6 6 8.162 6 10.799s2.162 4.8 4.799 4.8 4.8-2.163 4.8-4.8S13.437 6 10.8 6m0 2.398c1.34 0 2.4 1.061 2.4 2.4 0 1.34-1.06 2.401-2.4 2.401s-2.4-1.06-2.4-2.4 1.06-2.4 2.4-2.4"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
